import React, { useMemo, useState } from "react";
import EventTile from "../EventTile/EventTile";
import DayBucketGrid from "./DayBucketGrid";
import CardSelectorModal from "./CardSelectorModal";
import { resolveActivityPlanSlot } from "../../lib/activityPlanSlot";
import { FULL_DAY_CANONICAL_HOUR } from "../../lib/planBuckets";
import { isPlanRefOnDay } from "../../lib/planSlotRefs";

export default function WeeklyPlanView({
  columns,
  labels,
  listDescriptors = [],
  plan,
  addToSlot,
  removeFromSlot,
  dayDates,
  getSlotKey,
  dateRangeLabel,
  onBack,
}) {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [previewCard, setPreviewCard] = useState(null);

  const handleDayClick = (day) => setSelectedSlot({ day });
  const handleSelect = (ref) => {
    if (selectedSlot) {
      addToSlot(selectedSlot.day, FULL_DAY_CANONICAL_HOUR, ref);
      setSelectedSlot(null);
    }
  };

  const handleOpenCard = (colIndex, event) => {
    const events = columns[colIndex] ?? [];
    const eventIndex = events.findIndex((e) => e?.id === event?.id);
    const idx = eventIndex >= 0 ? eventIndex : 0;
    setPreviewCard({ colIndex, eventIndex: idx });
  };

  const modalColumns = useMemo(() => {
    if (!selectedSlot) return columns;
    return columns.map((col = [], colIndex) => {
      const columnId = listDescriptors[colIndex]?.id ?? colIndex;
      return col.filter((item, eventIndex) => {
        const slot = resolveActivityPlanSlot(item, dayDates);
        if (slot?.day !== selectedSlot.day) return false;
        const eventId = item?.id ?? eventIndex;
        return !isPlanRefOnDay(plan.slots ?? {}, selectedSlot.day, getSlotKey, {
          columnId,
          eventId,
        });
      });
    });
  }, [columns, dayDates, selectedSlot, plan.slots, getSlotKey, listDescriptors]);

  if (previewCard !== null) {
    const { colIndex, eventIndex } = previewCard;
    return (
      <div className="fullscreen-wrapper">
        <EventTile
          titleLabel={labels[colIndex]}
          events={columns[colIndex]}
          columnIndex={colIndex}
          columnMeta={listDescriptors[colIndex]}
          sharedEventIndex={eventIndex}
          isFullscreen={true}
          exitFullscreen={() => setPreviewCard(null)}
          onAddToSlot={addToSlot}
          planDayDates={dayDates}
          planSlots={plan.slots}
          getSlotKey={getSlotKey}
        />
      </div>
    );
  }

  return (
    <div className="plan-view">
      <div className="plan-view-header">
        <button type="button" className="plan-back-btn" onClick={onBack} aria-label="Zurück">
          ← Zurück
        </button>
        <h2 className="plan-view-title">Unser Plan</h2>
        <p className="plan-view-week">{dateRangeLabel}</p>
      </div>

      <DayBucketGrid
        slots={plan.slots ?? {}}
        columns={columns}
        columnDescriptors={listDescriptors}
        dayDates={dayDates}
        getSlotKey={getSlotKey}
        onDayClick={handleDayClick}
        onOpenCard={handleOpenCard}
        onRemove={removeFromSlot}
      />

      {selectedSlot && (
        <CardSelectorModal
          columns={modalColumns}
          sourceColumns={columns}
          listDescriptors={listDescriptors}
          onSelect={handleSelect}
          onClose={() => setSelectedSlot(null)}
        />
      )}
    </div>
  );
}
